<mat-toolbar class="content-header synth-header">
  <lib-button color="none" textColor="muted" icon="arrow_back" (click)="back()"
    [tooltip]="'synthesis.all_tenants' | translate"></lib-button>

  @if (tenant(); as tenant) {
  <span class="synth-tenant-icon" [style.--tenant-color]="tenant.color"><mat-icon>{{ tenant.icon }}</mat-icon></span>

  <div class="synth-header-titles">
    <button type="button" class="synth-tenant-switch" [matMenuTriggerFor]="tenantsMenu">
      <h1 class="synth-page-title">{{ tenant.name }}</h1>
      <mat-icon>expand_more</mat-icon>
    </button>
    <p class="synth-page-subtitle">
      <span class="synth-tenant">{{ 'synthesis.title' | translate }}</span>
      <span class="synth-dot">•</span>
      {{ 'companies.projects_count' | translate: { count: tenant.projects.length } }}
    </p>
  </div>
  }

  <mat-menu #tenantsMenu="matMenu" class="sub-menu">
    <button mat-menu-item routerLink="/synthesis">
      <mat-icon>apps</mat-icon>
      <span>{{ 'synthesis.all_tenants' | translate }}</span>
    </button>

    <mat-divider></mat-divider>

    @for (item of tenants(); track item.id) {
    <button mat-menu-item [routerLink]="['/synthesis', item.id, store.theme()]" [disabled]="item.id === tenant()?.id">
      <mat-icon [style.color]="item.color">{{ item.icon }}</mat-icon>
      <span>{{ item.name }}</span>
    </button>
    }
  </mat-menu>
</mat-toolbar>

<nav class="synth-tabs">
  @for (tab of tabs; track tab.route) {
  <a class="synth-tab" [routerLink]="tab.route" routerLinkActive="active">
    <mat-icon>{{ tab.icon }}</mat-icon>
    <span>{{ tab.label | translate }}</span>
  </a>
  }

  <!-- Same actions as the project dashboard, on a theme page -->
  @if (store.editorScope()) {
  <lib-action-group class="synth-tab-actions">
    @if (store.canEdit()) {
    <lib-button icon="add_chart" (click)="addWidget()" tooltip="{{ 'synthesis.add_widget' | translate }}"> </lib-button>
    }

    <lib-button customClass="refresh-btn" icon="refresh" color="secondary" (click)="refresh()"
      tooltip="{{ 'workflows.refresh' | translate }}">
    </lib-button>

    <lib-button [matMenuTriggerFor]="projectsMenu" icon="filter_list"
      [color]="store.isFiltered() ? 'primary' : 'secondary'" tooltip="{{ 'synthesis.filter_sites' | translate }}">
    </lib-button>
  </lib-action-group>
  }
</nav>

<mat-menu #projectsMenu="matMenu" class="sub-menu">
  <button mat-menu-item (click)="store.resetProjects()" [disabled]="!store.isFiltered()">
    <mat-icon>select_all</mat-icon>
    <span>{{ 'synthesis.select_all_sites' | translate }}</span>
  </button>

  @for (project of tenant()?.projects ?? []; track project.id) {
  <button mat-menu-item (click)="store.toggleProject(project.id); $event.stopPropagation()">
    <mat-icon [class.synth-check-on]="store.isProjectSelected(project.id)">
      {{ store.isProjectSelected(project.id) ? 'check_box' : 'check_box_outline_blank' }}
    </mat-icon>
    <span>{{ project.name }}</span>
  </button>
  }
</mat-menu>

<div class="synth-outlet">
  <router-outlet></router-outlet>
</div>